import { env } from "@/lib/env";

/**
 * Default organization IDs for each environment
 * These organizations exist to prevent orphan users
 * Users in these organizations should not have access to premium features like AskGemini
 */
const DEFAULT_ORGANIZATION_IDS = {
  dev: "64a3e107-3a3d-4fab-8ae3-01ccf9782843",
  localhost: "64a3e107-3a3d-4fab-8ae3-01ccf9782843",
  development: "64a3e107-3a3d-4fab-8ae3-01ccf9782843",
  staging: "8b69f5a9-08d6-4d87-a8d3-f90fd248d6dd",
  production: "b342f473-09ac-4af4-9c53-04aa20169388",
} as const;

/**
 * Get the Default organization ID for the current environment
 */
export const DEFAULT_ORGANIZATION_ID =
  DEFAULT_ORGANIZATION_IDS[
    (env.EXPO_PUBLIC_ENV as keyof typeof DEFAULT_ORGANIZATION_IDS) ||
      "production"
  ] || DEFAULT_ORGANIZATION_IDS.production;
